import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from '@octano/global-ui';
import { SecureResponseFile } from '../../../components/AzureFilesUploader/types';

type AnnouncementFileProps = {
  file: SecureResponseFile;
};

const AnnouncementFile = ({ file }: AnnouncementFileProps) => {
  const { t } = useTranslation();

  const handleDownload = useCallback(() => {
    if (!file?.url) {
      return;
    }

    window.open(file?.url, '_blank');
  }, [file?.url]);

  return (
    <div
      className="d-flex flex-column w-100"
      style={{ gap: 10, maxWidth: 208 }}
    >
      <span className="fs-18 fw-700 text-secondary flex-fill">{`${file.name}.${file.extension}`}</span>
      <div
        className="w-full bg-light px-3 py-3 d-flex flex-column align-items-center justify-content-end rounded"
        style={{ gap: 25 }}
      >
        <Icon name="file_pdf" size={50} className="mt-2" />
        <Button
          text={t('common:actions.download')}
          size="sm"
          icon="download"
          className="w-100"
          fullwidth
          type="button"
          onClick={handleDownload}
        />
      </div>
    </div>
  );
};

export default AnnouncementFile;
